import { cn } from '@/lib/utils';

/**
 * On/off switch. The knob is always white and the track carries the state (brand cobalt when on,
 * the input tone when off), so it reads in both themes. Don't build the track from `bg-primary`:
 * primary is near-white in dark mode, which hid a `bg-background` knob entirely.
 */
export function Switch({
  checked, onCheckedChange, disabled, className, 'aria-label': ariaLabel,
}: {
  checked: boolean;
  onCheckedChange: (next: boolean) => void;
  disabled?: boolean;
  className?: string;
  'aria-label'?: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => onCheckedChange(!checked)}
      className={cn(
        'relative inline-flex h-5 w-9 shrink-0 items-center rounded-full border border-transparent transition-colors',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
        'disabled:cursor-not-allowed disabled:opacity-50',
        checked ? 'bg-brand' : 'bg-input border-border',
        className,
      )}
    >
      <span
        aria-hidden
        className={cn(
          'pointer-events-none block h-4 w-4 rounded-full bg-white shadow-sm ring-0 transition-transform',
          checked ? 'translate-x-[16px]' : 'translate-x-0.5',
        )}
      />
    </button>
  );
}
